// Portal sections an admin can switch on per project. The left menu (and the mobile burger)
// is only shown when at least two of these are visible; with one, the portal lands straight
// on that section with no menu.
const SECTION_FLAGS = [
  "bDashboardVisible",
  "bReviewFeedVisible",
  "bAIInsightsVisible",
  "bReviewConsolidationVisible",
  "bCommentAnalysisVisible",
  "bLeagueTablesVisible",
  "bLoginReportVisible",
  "bDownloadsVisible",
  "bQuicksightVisible",
] as const;

type SectionFlags = Partial<Record<(typeof SECTION_FLAGS)[number], boolean | null | undefined>>;

export const countVisibleSections = (details: SectionFlags): number =>
  SECTION_FLAGS.filter(flag => Boolean(details[flag])).length;
